module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"signIn":"Вход","done":"Войти","close":"Закрыть"},"uk":{"signIn":"Вхід","done":"Увійти","close":"Закрити"}}')
  delete Component.options._Ctor
}
